// import React, { useEffect, useState } from "react";
// import {
//   Layout,
//   Row,
//   Col,
//   Card,
//   Typography,
//   Avatar,
//   Tag,
//   List,
//   Button,
//   Empty,
//   Space,
//   message,
// } from "antd";
// import {
//   UserOutlined,
//   CheckCircleOutlined,
//   CloseCircleOutlined,
//   PieChartOutlined,
//   BarChartOutlined,
//   MenuOutlined,
// } from "@ant-design/icons";
// import CountUp from "react-countup";
// import axios from "axios";
// import {
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   PieChart,
//   Pie,
//   Cell,
//   Legend,
// } from "recharts";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import { BASE_URL } from "../Config";

// const { Header, Content } = Layout;
// const { Title, Paragraph, Text } = Typography;

// const CHART_COLORS = ["#4f46e5", "#06b6d4", "#f59e0b", "#ef4444"];

// const Dashboard = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const [loading, setLoading] = useState(false);

//   const [stats, setStats] = useState({
//     totalVariations: 0,
//     pending: 0,
//     approved: 0,
//     rejected: 0,
//   });

//   const [lineData, setLineData] = useState([]);
//   const [pieData, setPieData] = useState([]);
//   const [pendingApprovals, setPendingApprovals] = useState([]);
//   const [recentActivities, setRecentActivities] = useState([]);

//   const navigate = useNavigate();

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   const fetchDashboard = async () => {
//     try {
//       setLoading(true);

//       const token = sessionStorage.getItem("token");

//       const countRes = await axios.get(`${BASE_URL}/dashboard/counts`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setStats(countRes.data.data);

//       const monthRes = await axios.get(`${BASE_URL}/dashboard/charts/monthly`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setLineData(monthRes.data.data);

//       const statusRes = await axios.get(`${BASE_URL}/dashboard/charts/status`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setPieData(
//         statusRes.data.data.map((item) => ({
//           name: item._id,
//           value: item.count,
//         })),
//       );

//       const pendingRes = await axios.get(`${BASE_URL}/userasanas`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setPendingApprovals(
//         pendingRes.data.asanas.filter((x) => x.status === "pending"),
//       );

//       const recentRes = await axios.get(`${BASE_URL}/dashboard/recent`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setRecentActivities(
//         recentRes.data.data.map((item) => ({
//           _id: item._id,
//           title: `${item.name} submitted`,
//           by: item.userId?.name || "User",
//           at: new Date(item.createdAt).toLocaleString(),
//           status: item.status,
//         })),
//       );
//     } catch (err) {
//       console.error("Dashboard fetch error", err);
//       message.error("Failed to load dashboard");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDashboard();
//   }, []);

//   const auth = {
//     headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
//   };

//   const approve = async (id) => {
//     await axios.put(`${BASE_URL}/userasanas/approve/${id}`, {}, auth);
//     message.success("Approved");
//     fetchDashboard();
//   };

//   const reject = async (id) => {
//     await axios.put(`${BASE_URL}/userasanas/reject/${id}`, {}, auth);
//     message.success("Rejected");
//     fetchDashboard();
//   };

//   const StatCard = ({ title, value, icon, color }) => (
//     <Card style={{ borderRadius: 12, minHeight: 110, background: "#fff" }}>
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <div>
//           <Text type="secondary">{title}</Text>
//           <div style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
//             <Title level={3} style={{ margin: 0 }}>
//               <CountUp end={value} duration={1.2} />
//             </Title>
//             <Avatar
//               style={{
//                 background: color,
//                 marginLeft: 12,
//                 boxShadow: "0 6px 14px rgba(0,0,0,0.06)",
//               }}
//               icon={icon}
//             />
//           </div>
//         </div>
//       </div>
//     </Card>
//   );

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//         role="admin"
//       />
//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <Title level={4}>Yoga Wellness</Title>
//             <Text type="secondary">Admin dashboard</Text>
//           </div>
//         </Header>

//         <Content style={{ padding: 24 }}>
//           <Row gutter={[16, 16]}>
//             <Col xs={24} sm={12} md={6}>
//               <StatCard
//                 title="Total Variations"
//                 value={stats.totalVariations}
//                 icon={<BarChartOutlined />}
//                 color="#4f46e5"
//               />
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <StatCard
//                 title="Pending"
//                 value={stats.pending}
//                 icon={<PieChartOutlined />}
//                 color="#f59e0b"
//               />
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <StatCard
//                 title="Approved"
//                 value={stats.approved}
//                 icon={<CheckCircleOutlined />}
//                 color="#10b981"
//               />
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <StatCard
//                 title="Rejected"
//                 value={stats.rejected}
//                 icon={<CloseCircleOutlined />}
//                 color="#ef4444"
//               />
//             </Col>
//           </Row>

//           <Row gutter={[16, 16]} style={{ marginTop: 18 }}>
//             <Col xs={24} lg={16}>
//               <Card style={{ borderRadius: 12 }}>
//                 <Title level={5}>Reports</Title>
//                 <ResponsiveContainer width="100%" height={260}>
//                   <LineChart data={lineData}>
//                     <XAxis dataKey="month" />
//                     <YAxis />
//                     <Tooltip />
//                     <Line
//                       type="monotone"
//                       dataKey="count"
//                       stroke="#4f46e5"
//                       strokeWidth={3}
//                     />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </Card>
//             </Col>

//             <Col xs={24} lg={8}>
//               <Card style={{ borderRadius: 12 }}>
//                 <Title level={5}>Submission Status</Title>
//                 <ResponsiveContainer width="100%" height={260}>
//                   <PieChart>
//                     <Pie
//                       data={pieData}
//                       dataKey="value"
//                       nameKey="name"
//                       innerRadius={"60%"}
//                       outerRadius={"80%"}
//                     >
//                       {pieData.map((p, i) => (
//                         <Cell key={i} fill={CHART_COLORS[i]} />
//                       ))}
//                     </Pie>
//                     <Legend />
//                     <Tooltip />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </Card>
//             </Col>
//           </Row>

//           {/* Approvals + Recent */}
//           <Row gutter={[16, 16]} style={{ marginTop: 18 }}>
//             <Col xs={24} lg={12}>
//               <Card style={{ borderRadius: 12 }}>
//                 <Title level={5}>Pending Approvals</Title>

//                 {pendingApprovals?.length === 0 ? (
//                   <Empty description="No Pending Approvals" />
//                 ) : (
//                   <List
//                     dataSource={pendingApprovals}
//                     renderItem={(item) => (
//                       <List.Item
//                         actions={[
//                           <Button
//                             type="primary"
//                             onClick={() => approve(item._id)}
//                           >
//                             Approve
//                           </Button>,
//                           <Button danger onClick={() => reject(item._id)}>
//                             Reject
//                           </Button>,
//                         ]}
//                       >
//                         <List.Item.Meta
//                           avatar={<Avatar icon={<UserOutlined />} />}
//                           title={item.name}
//                           description={`By ${item.userId?.name || "User"
//                             } • ${new Date(item.createdAt).toLocaleString()}`}
//                         />
//                       </List.Item>
//                     )}
//                   />
//                 )}
//               </Card>
//             </Col>

//             <Col xs={24} lg={12}>
//               <Card style={{ borderRadius: 12 }}>
//                 <Title level={5}>Recent Activities</Title>

//                 <List
//                   dataSource={recentActivities}
//                   renderItem={(it) => (
//                     <List.Item>
//                       <List.Item.Meta
//                         avatar={
//                           <Avatar
//                             style={{ background: "#eef2ff", color: "#4f46e5" }}
//                           >
//                             {it.by?.[0]}
//                           </Avatar>
//                         }
//                         title={
//                           <>
//                             {it.title}
//                             <Tag
//                               color={
//                                 it.status === "approved"
//                                   ? "green"
//                                   : it.status === "pending"
//                                     ? "orange"
//                                     : "red"
//                               }
//                               style={{ marginLeft: 10 }}
//                             >
//                               {it.status}
//                             </Tag>
//                           </>
//                         }
//                         description={`${it.by} • ${it.at}`}
//                       />
//                     </List.Item>
//                   )}
//                 />
//               </Card>
//             </Col>
//           </Row>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from "react";
import {
  Layout, Row, Col, Card, Typography, Avatar,
  Tag, List, Button, Empty, Space, message, Select,
} from "antd";
import {
  UserOutlined, CheckCircleOutlined, CloseCircleOutlined,
  PieChartOutlined, BarChartOutlined, MenuOutlined,
  ArrowRightOutlined, TrophyOutlined,
} from "@ant-design/icons";
import CountUp from "react-countup";
import axios from "axios";
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis,
  Tooltip, PieChart, Pie, Cell, Legend,
} from "recharts";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";

const { Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;

const COLORS = {
  purple: "#4f46e5",
  amber:  "#f59e0b",
  green:  "#10b981",
  red:    "#ef4444",
  cyan:   "#06b6d4",
};

const PIE_COLORS = [COLORS.purple, COLORS.amber, COLORS.red, COLORS.cyan];

const Dashboard = () => {
  const [collapsed, setCollapsed]       = useState(false);
  const [isMobile, setIsMobile]         = useState(false);
  const [mobileOpen, setMobileOpen]     = useState(false);
  const [loading, setLoading]           = useState(false);
  const [stats, setStats]               = useState({ totalVariations: 0, pending: 0, approved: 0, rejected: 0 });
  const [lineData, setLineData]         = useState([]);
  const [pieData, setPieData]           = useState([]);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const h = { headers: { Authorization: `Bearer ${token}` } };

      const [countRes, monthRes, statusRes, pendingRes, recentRes] = await Promise.all([
        axios.get(`${BASE_URL}/dashboard/counts`, h),
        axios.get(`${BASE_URL}/dashboard/charts/monthly`, h),
        axios.get(`${BASE_URL}/dashboard/charts/status`, h),
        axios.get(`${BASE_URL}/userasanas`, h),
        axios.get(`${BASE_URL}/dashboard/recent`, h),
      ]);

      setStats(countRes.data.data);
      setLineData(monthRes.data.data);
      setPieData(statusRes.data.data.map((item) => ({ name: item._id, value: item.count })));
      setPendingApprovals(pendingRes.data.asanas.filter((x) => x.status === "pending"));
      setRecentActivities(recentRes.data.data.map((item) => ({
        _id: item._id,
        title: `${item.name} submitted`,
        by: item.userId?.name || "User",
        at: new Date(item.createdAt).toLocaleString(),
        status: item.status,
      })));
    } catch (err) {
      message.error("Failed to load dashboard");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchDashboard(); }, []);

  const auth = { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } };

  const approve = async (id) => {
    await axios.put(`${BASE_URL}/userasanas/approve/${id}`, {}, auth);
    message.success("Approved");
    fetchDashboard();
  };

  const reject = async (id) => {
    await axios.put(`${BASE_URL}/userasanas/reject/${id}`, {}, auth);
    message.success("Rejected");
    fetchDashboard();
  };

  // ── Stat card matching screenshot ──────────────────────
  const StatCard = ({ title, subtitle, value, icon, color, bgColor, sparkData }) => (
    <Card
      style={{ borderRadius: 16, border: "1px solid #f0f0f0", overflow: "hidden" }}
      bodyStyle={{ padding: 0 }}
    >
      <div style={{ padding: "18px 20px 0" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
          <div style={{
            width: 42, height: 42, borderRadius: 12,
            background: bgColor, display: "flex",
            alignItems: "center", justifyContent: "center",
          }}>
            {React.cloneElement(icon, { style: { fontSize: 20, color } })}
          </div>
        </div>
        <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1, marginBottom: 4, color: "#111" }}>
          <CountUp end={value} duration={1.2} />
        </div>
        <div style={{ fontSize: 13, color: "#888", marginBottom: 2 }}>{title}</div>
        <div style={{ fontSize: 11, color: "#aaa", marginBottom: 10 }}>{subtitle}</div>
      </div>
      {/* Mini sparkline */}
      <div style={{ height: 50 }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={sparkData || lineData.slice(-6)}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient id={`grad-${color.replace("#","")}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.2}/>
                <stop offset="95%" stopColor={color} stopOpacity={0}/>
              </linearGradient>
            </defs>
            <Area type="monotone" dataKey="count" stroke={color} strokeWidth={2}
              fill={`url(#grad-${color.replace("#","")})`} dot={false}/>
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );

  const totalPie = pieData.reduce((s, d) => s + d.value, 0);
  const allUpToDate = pieData.every((d) => d.name === "approved" || d.value === 0);

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />

      <Layout style={{
        marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
        transition: "margin 0.3s",
      }}>
        {/* Header */}
        <div className="MainHeader" style={{
          display: "flex", alignItems: "center",
          padding: isMobile ? "0 16px" : "0 24px",
        }}>
          {isMobile && (
            <Button type="text" icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}/>
          )}
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{
                width: 32, height: 32, borderRadius: 8,
                background: "#eef2ff", display: "flex",
                alignItems: "center", justifyContent: "center",
              }}>
                <BarChartOutlined style={{ color: "#4f46e5", fontSize: 16 }}/>
              </div>
              <div>
                <Title level={5} style={{ margin: 0 }}>YogaRefer.com</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>Admin dashboard overview</Text>
              </div>
            </div>
          </div>
          <Select defaultValue="thisYear" style={{ width: 130 }}>
            <Option value="thisYear">📅 This Year</Option>
            <Option value="lastYear">Last Year</Option>
            <Option value="allTime">All Time</Option>
          </Select>
        </div>

        <Content style={{ padding: isMobile ? 12 : 24 }}>

          {/* ── Stat cards ── */}
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={6}>
              <StatCard title="Total Uploads" subtitle="All Uploads"
                value={stats.totalVariations}
                icon={<BarChartOutlined />}
                color={COLORS.purple} bgColor="#eef2ff"/>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <StatCard title="Pending" subtitle="Awaiting review"
                value={stats.pending}
                icon={<PieChartOutlined />}
                color={COLORS.amber} bgColor="#fffbeb"/>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <StatCard title="Approved" subtitle="Successfully approved"
                value={stats.approved}
                icon={<CheckCircleOutlined />}
                color={COLORS.green} bgColor="#ecfdf5"/>
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <StatCard title="Rejected" subtitle="Require attention"
                value={stats.rejected}
                icon={<CloseCircleOutlined />}
                color={COLORS.red} bgColor="#fef2f2"/>
            </Col>
          </Row>

          {/* ── Charts row ── */}
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>

            {/* Area chart */}
            <Col xs={24} lg={16}>
              <Card style={{ borderRadius: 16, border: "1px solid #f0f0f0" }}
                bodyStyle={{ padding: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between",
                  alignItems: "center", marginBottom: 16 }}>
                  <Title level={5} style={{ margin: 0 }}>Reports Overview</Title>
                  <Select defaultValue="monthly" size="small" style={{ width: 110 }}>
                    <Option value="monthly">Monthly</Option>
                    <Option value="weekly">Weekly</Option>
                  </Select>
                </div>
                <ResponsiveContainer width="100%" height={220}>
                  <AreaChart data={lineData} margin={{ top: 5, right: 10, bottom: 0, left: -20 }}>
                    <defs>
                      <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.15}/>
                        <stop offset="95%" stopColor="#4f46e5" stopOpacity={0}/>
                      </linearGradient>
                    </defs>
                    <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#aaa" }} axisLine={false} tickLine={false}/>
                    <YAxis tick={{ fontSize: 11, fill: "#aaa" }} axisLine={false} tickLine={false}/>
                    <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12, border: "1px solid #eee" }}/>
                    <Area type="monotone" dataKey="count" stroke="#4f46e5" strokeWidth={2.5}
                      fill="url(#areaGrad)" dot={{ fill: "#4f46e5", r: 3, strokeWidth: 0 }}
                      activeDot={{ r: 5 }}/>
                  </AreaChart>
                </ResponsiveContainer>
              </Card>
            </Col>

            {/* Donut chart */}
            <Col xs={24} lg={8}>
              <Card style={{ borderRadius: 16, border: "1px solid #f0f0f0", height: "100%" }}
                bodyStyle={{ padding: 20 }}>
                <Title level={5} style={{ margin: "0 0 8px" }}>Submission Status</Title>
                <ResponsiveContainer width="100%" height={200}>
                  <PieChart>
                    <Pie data={pieData} dataKey="value" nameKey="name"
                      innerRadius="58%" outerRadius="78%" paddingAngle={2}>
                      {pieData.map((_, i) => (
                        <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]}/>
                      ))}
                    </Pie>
                    <text x="50%" y="47%" textAnchor="middle" dominantBaseline="middle"
                      style={{ fontSize: 24, fontWeight: 700, fill: "#111" }}>
                      {totalPie}
                    </text>
                    <text x="50%" y="57%" textAnchor="middle" dominantBaseline="middle"
                      style={{ fontSize: 11, fill: "#aaa" }}>
                      Total
                    </text>
                    <Legend iconType="circle" iconSize={8}
                      formatter={(value, entry) => (
                        <span style={{ fontSize: 12, color: "#555" }}>
                          {value} &nbsp;
                          <span style={{ color: "#aaa" }}>
                            {totalPie ? Math.round((entry.payload.value / totalPie) * 100) : 0}%
                          </span>
                        </span>
                      )}/>
                    <Tooltip contentStyle={{ borderRadius: 8, fontSize: 12 }}/>
                  </PieChart>
                </ResponsiveContainer>

                {/* Great work banner */}
                {allUpToDate && (
                  <div style={{
                    marginTop: 8, background: "#fffbeb", borderRadius: 10,
                    border: "1px solid #fde68a", padding: "10px 14px",
                    display: "flex", alignItems: "center", gap: 10,
                  }}>
                    <TrophyOutlined style={{ color: "#f59e0b", fontSize: 20 }}/>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13, color: "#92400e" }}>Great work!</div>
                      <div style={{ fontSize: 11, color: "#b45309" }}>All submissions are up to date.</div>
                    </div>
                  </div>
                )}
              </Card>
            </Col>
          </Row>

          {/* ── Bottom row ── */}
          <Row gutter={[16, 16]} style={{ marginTop: 16 }}>

            {/* Pending approvals */}
            <Col xs={24} lg={12}>
              <Card style={{ borderRadius: 16, border: "1px solid #f0f0f0" }}
                bodyStyle={{ padding: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between",
                  alignItems: "center", marginBottom: 4 }}>
                  <div>
                    <Title level={5} style={{ margin: 0 }}>Pending Approvals</Title>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      Variations awaiting your review
                    </Text>
                  </div>
                
                </div>

                {pendingApprovals.length === 0 ? (
                  <Empty description="No pending approvals" style={{ padding: "20px 0" }}/>
                ) : (
                  <List
                    dataSource={pendingApprovals}
                    renderItem={(item) => (
                      <List.Item style={{ padding: "12px 0", borderBottom: "1px solid #f5f5f5" }}>
                        <List.Item.Meta
                          avatar={
                            <Avatar style={{ background: "#eef2ff", color: "#4f46e5" }}
                              icon={<UserOutlined />}/>
                          }
                          title={<span style={{ fontSize: 14, fontWeight: 500 }}>{item.name}</span>}
                          description={
                            <span style={{ fontSize: 12, color: "#aaa" }}>
                              By {item.userId?.name || "User"} •{" "}
                              {new Date(item.createdAt).toLocaleString()}
                            </span>
                          }
                        />
                        {/* <Space>
                          <Button size="small" type="primary"
                            icon={<CheckCircleOutlined />}
                            onClick={() => approve(item._id)}
                            style={{ background: "#4f46e5", borderColor: "#4f46e5", borderRadius: 8 }}>
                            Approve
                          </Button>
                          <Button size="small" danger
                            icon={<CloseCircleOutlined />}
                            onClick={() => reject(item._id)}
                            style={{ borderRadius: 8 }}>
                            Reject
                          </Button>
                        </Space> */}
                      </List.Item>
                    )}
                  />
                )}
              </Card>
            </Col>

            {/* Recent activities */}
            <Col xs={24} lg={12}>
              <Card style={{ borderRadius: 16, border: "1px solid #f0f0f0" }}
                bodyStyle={{ padding: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between",
                  alignItems: "center", marginBottom: 4 }}>
                  <div>
                    <Title level={5} style={{ margin: 0 }}>Recent Activities</Title>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      Latest actions performed in the system
                    </Text>
                  </div>
                 
                </div>

                <List
                  dataSource={recentActivities}
                  renderItem={(it) => (
                    <List.Item style={{ padding: "12px 0", borderBottom: "1px solid #f5f5f5" }}>
                      <List.Item.Meta
                        avatar={
                          <div style={{ position: "relative" }}>
                            <Avatar style={{ background: "#eef2ff", color: "#4f46e5", fontWeight: 600 }}>
                              {it.by?.[0]?.toUpperCase()}
                            </Avatar>
                            {/* Status dot */}
                            <div style={{
                              position: "absolute", bottom: 0, right: 0,
                              width: 10, height: 10, borderRadius: "50%",
                              border: "2px solid #fff",
                              background: it.status === "approved" ? "#10b981"
                                : it.status === "pending" ? "#f59e0b" : "#ef4444",
                            }}/>
                          </div>
                        }
                        title={
                          <span style={{ fontSize: 13 }}>
                            {it.title}{" "}
                            <Tag color={
                              it.status === "approved" ? "green"
                              : it.status === "pending" ? "orange" : "red"
                            } style={{ fontSize: 11, borderRadius: 6, marginLeft: 4 }}>
                              {it.status}
                            </Tag>
                          </span>
                        }
                        description={
                          <span style={{ fontSize: 12, color: "#aaa" }}>
                            {it.by} • {it.at}
                          </span>
                        }
                      />
                    </List.Item>
                  )}
                />
              </Card>
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
